import React, { Component } from 'react'
import styled from 'styled-components'
import firebase from 'firebase/app'
import _ from 'lodash'
import moment from 'moment'
import { Segment, Grid, Header, Table } from 'semantic-ui-react'

import Loading from '../../components/common/loading'

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

class CashReceivable extends Component {
  state = {
    drivers: [],
    loading: true,
  }

  componentDidMount() {
    this.getDrivers()
  }

  getBackgroundColor = balance => {
    const white = '#fff'
    const red = '#F9D9DC'
    const orange = '#fff0dc'

    let color = white

    if (balance <= -20) {
      color = red
    } else if (balance <= -10) {
      color = orange
    }

    return color
  }

  getDrivers = async () => {
    const ref = firebase.database().ref('deliverers')
    const snapshots = await ref.once('value')
    const drivers = []

    snapshots.forEach(snapshot => {
      const driver = snapshot.val()

      if (driver.cash_balance < 0) {
        drivers.push({ ...driver, uid: snapshot.key })
      }
    })

    this.setState({ drivers, loading: false })
  }

  renderCashReceivableRow = () => {
    const { drivers } = this.state

    return drivers.map((driver, index) => (
      <Table.Row style={{ backgroundColor: this.getBackgroundColor(driver.cash_balance) }} >
        <Table.Cell style={{ paddingLeft: 11 }}>
          {`${index + 1}`}
        </Table.Cell>
        <Table.Cell>
          {`${driver.family_name} ${driver.first_name}`}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {driver.tel}
        </Table.Cell>
        <Table.Cell>
          { moment(driver.last_session).fromNow() }
        </Table.Cell>
        <Table.Cell textAlign="center">
          {driver.credit_balance}
        </Table.Cell>
        <Table.Cell textAlign="center" style={{ fontSize: 17, fontWeight: 'bold' }}>
          {driver.cash_balance}
        </Table.Cell>
      </Table.Row>
    ))
  }

  renderNoDrivers = () => (
    <Table.Row>
      <Table.Cell colSpan={4} textAlign="center">No Drivers</Table.Cell>
    </Table.Row>
  )

  render() {
    const { drivers, loading } = this.state
    const totalCashBalance = _.sum(drivers.map(driver => driver.cash_balance))

    return (
      <div>
        <Loading active={loading} />
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
            <HeaderContainer>
              <Header size="large" style={{ marginBottom: 0 }} >
                Cash Receivable ({_.size(drivers)})
              </Header>
              <HeaderLeft>
                {drivers.length > 0
                  ? <Header size="large" color='red' style={{ marginRight: 10 }}>Total: {parseFloat(totalCashBalance).toFixed(2)}</Header>
                  : null
                }
              </HeaderLeft>
            </HeaderContainer>

              <Table basic="very" style={{ marginTop: 30 }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell style={{ paddingLeft: 11 }}>
                      No.
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Driver Name
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Phone
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Last Session
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Credit Wallet
                    </Table.HeaderCell>
                    <Table.HeaderCell style={{ fontSize: 17, fontWeight: 'bold' }} textAlign="center">
                      Cash Wallet
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {drivers.length > 0 ? this.renderCashReceivableRow() : this.renderNoDrivers()}
                </Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

export default CashReceivable



// WEBPACK FOOTER //
// ./src/containers/cashReceivable/index.js